var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46587 8.01311L15.696 1.78284C16.1014 1.37759 16.1014 0.722346 15.696 0.317093C15.2907 -0.0881603 14.6355 -0.0881603 14.2302 0.317093L7.99993 6.54737L1.76983 0.317093C1.36439 -0.0881603 0.709337 -0.0881603 0.304083 0.317093C-0.101361 0.722346 -0.101361 1.37759 0.304083 1.78284L6.53418 8.01311L0.304083 14.2434C-0.101361 14.6486 -0.101361 15.3039 0.304083 15.7091C0.506046 15.9113 0.771596 16.0128 1.03696 16.0128C1.30232 16.0128 1.56768 15.9113 1.76983 15.7091L7.99993 9.47886L14.2302 15.7091C14.4324 15.9113 14.6977 16.0128 14.9631 16.0128C15.2284 16.0128 15.4938 15.9113 15.696 15.7091C16.1014 15.3039 16.1014 14.6486 15.696 14.2434L9.46587 8.01311Z",
    fill: "#272D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.ba968d44f6275c377283f4ef5b77cb19.svg";
export { ForwardRef as ReactComponent };